import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { SignalRService } from '../core/services/signalr-service'

@Component({
    selector: 'sf-public',
    imports: [RouterOutlet],
    templateUrl: './public.component.html',
    styleUrls: ['./public.component.scss'],
})
export class PublicComponent implements OnInit, OnDestroy {
    // signalRService = inject(SignalRService)
    destroyRef = inject(DestroyRef)

    ngOnInit() {
        // this.signalRService.initiatePublicSignalrConnection()
    }

    ngOnDestroy(): void {
        // this.signalRService.endConnection()
    }
}
